import _asyncToGenerator from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/circleci/project/node_modules/@babel/runtime/regenerator/index.js";
import { createWrapper, resolveWhen } from '@segment/analytics-consent-tools';
import { getNormalizedCategories, getNormalizedActiveGroupIds, getOneTrustGlobal, coerceConsentModel } from '../lib/onetrust-api';
/**
 *
 * @param analyticsInstance - An analytics instance. Either `window.analytics`, or the instance returned by `new AnalyticsBrowser()` or `AnalyticsBrowser.load({...})`
 * @param settings - Optional settings for configuring your OneTrust wrapper
 */
export var withOneTrust = function withOneTrust(analyticsInstance) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return createWrapper({
    // wait for OneTrust global to be available before wrapper is loaded
    shouldLoadWrapper: function () {
      var _shouldLoadWrapper = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return resolveWhen(function () {
                return getOneTrustGlobal() !== undefined;
              }, 500);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function shouldLoadWrapper() {
        return _shouldLoadWrapper.apply(this, arguments);
      }
      return shouldLoadWrapper;
    }(),
    shouldLoadSegment: function () {
      var _shouldLoadSegment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ctx) {
        var _settings$consentMode;
        var OneTrust, consentModel;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              OneTrust = getOneTrustGlobal();
              consentModel = ((_settings$consentMode = settings.consentModel) === null || _settings$consentMode === void 0 ? void 0 : _settings$consentMode.call(settings)) || coerceConsentModel(OneTrust.GetDomainData().ConsentModel.Name);
              if (!(consentModel === 'opt-out')) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", ctx.load({
                consentModel: 'opt-out'
              }));
            case 6:
              _context2.next = 8;
              return resolveWhen(function () {
                return (
                  // if any groups at all are consented to
                  Boolean(getNormalizedActiveGroupIds().length) && (
                  // if show banner is unchecked in the UI
                  OneTrust.GetDomainData().ShowAlertNotice === false ||
                  // if alert box is closed by end user
                  OneTrust.IsAlertBoxClosed())
                );
              }, 500);
            case 8:
              return _context2.abrupt("return", ctx.load({
                consentModel: 'opt-in'
              }));
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function shouldLoadSegment(_x) {
        return _shouldLoadSegment.apply(this, arguments);
      }
      return shouldLoadSegment;
    }(),
    getCategories: function getCategories() {
      var results = getNormalizedCategories();
      return results;
    },
    registerOnConsentChanged: settings.disableConsentChangedEvent ? undefined : function (setCategories) {
      getOneTrustGlobal().OnConsentChanged(function (event) {
        var normalizedCategories = getNormalizedCategories(event.detail);
        setCategories(normalizedCategories);
      });
    },
    integrationCategoryMappings: settings.integrationCategoryMappings,
    enableDebugLogging: settings.enableDebugLogging
  })(analyticsInstance);
};